import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__clearable-dropdown > input[type="hidden"]';
export default class ClearableDropdown {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        $elements.each((index, element) => this.handleValueChange($(element)));
        $elements.on('change', event => this.handleValueChange($(event.currentTarget)));
    }
    static handleValueChange($element) {
        $element.siblings('.icon').toggleClass('clear', !!$element.val());
    }
}
